import React, { useState } from "react";
import { SignupSlide } from "./AuthComponent";
import { useNavigate, useParams } from "react-router";
import { UserApi } from "../../app/api/user.api";
import './Login.css';


export function ResendEmail() 
{   
    const navigate = useNavigate();
    const { email } = useParams();
    const user = UserApi();

    const [resendMessage, setResendMessage] = useState("");
    const [resendStatus, setResendStatus] = useState(0);
    const [resendLoading, setResendLoading] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const handleResendEmail = async () => {
      setResendLoading(true);
      setResendStatus(0);
      try {
        const { data } = await user.updateEmail({ email: email });
        setResendLoading(false);
        if (data.success) {
          setResendStatus(1);
          setIsButtonDisabled(true);
          setResendMessage("Email de confirmation renvoyé avec succès.");
        } else {
          setResendStatus(-1);
          setResendMessage("Erreur lors du renvoi de l'email. Veuillez réessayer.");
        }
      } catch (err) 
      {
        setResendLoading(false);
        setResendStatus(-1);
        const response = err?.response?.data;

        if (response?.message) {
          setResendMessage(response.message);
        } else if (Array.isArray(response?.errors) && response.errors.length > 0) {
          setResendMessage(response.errors[0].msg || response.errors[0]);
        } else {
          setResendMessage("Une erreur est survenue. Veuillez réessayer.");
        }
      }
      finally {
        setTimeout(() => {
          setResendStatus(0);
          setResendMessage("");
          setIsButtonDisabled(false);
        }, 30000);
      }
    }

    return(

        <div className="container-fluid">
          <div className="row justify-content-center align-items-center" style={{minHeight: '100vh', backgroundColor: '#f5f5f5'}}>
            <div className="col-lg-10 col-md-11 col-sm-12">

                <section className="hottest-deals-container container-fluid px-0 border bg-light">
                  <div className="row g-0">

                    {/* Colonne de gauche : Contenu Textuel (Le Slider) */}
                    <SignupSlide />

                    {/* Colonne de droite : Image */}
                    <div className="col-md-7 py-5 order-1 order-md-2">
                      <div className="row justify-content-center">
                        <div className="col-sm-10 col-11">

                            <div className="d-flex mb-4">
                                <button onClick={() => navigate(-1)} className='btn btn-sm btn-outline-dark'> <i className="bi bi-chevron-left"></i> Retour </button>
                            </div>

                            <div className="d-flex flex-column text-center px-4">
                                <div className="mb-3">
                                   <i className="bi bi-check-circle text-green" style={{ fontSize: '3rem' }}></i>
                                </div>
                                <p className="text-secondary">
                                  Un email d'activation a été envoyé à l'adresse indiquée <strong> ( { email } ) </strong> lors de votre inscription.
                                </p>
                                <p className="text-muted small">
                                   Vérifiez votre boîte de réception et suivez les instructions d'activation de votre compte utilisateur. Si vous ne voyez pas l'email, vérifiez votre dossier de spam ou de courrier indésirable.
                                </p>
                                <div className="mb-3 d-flex flex-column">
                                    {
                                      resendStatus === 1 &&  (
                                        <div className="d-flex flex-column">
                                          <span className="alert alert-success small py-1"> { resendMessage } </span>
                                          <span className="text-secondary text-x-small mt-2"> Veuillez patienter 30s avant de réessayer. </span>
                                        </div>
                                      )
                                    }
                                    {
                                      resendStatus === -1 && (
                                        <div className="d-flex flex-column">
                                          <span className="alert alert-danger small py-1"> { resendMessage } </span>
                                          <span className="text-secondary text-x-small mt-2"> Veuillez patienter 30s avant de réessayer. </span>
                                        </div>
                                      )
                                    }
                                </div>
                                <button className="btn btn-green py-2 px-4" onClick={handleResendEmail} disabled={resendLoading || isButtonDisabled}>
                                    { 
                                      resendLoading ? (
                                       <>
                                         <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                         Envoi en cours...
                                       </>
                                      ) : (
                                       <>
                                         <span>Renvoyer l'email</span>
                                         <i className="bi bi-chevron-right ms-2"></i>
                                       </>
                                      ) 
                                    }
                                </button>
                            </div>
                
                        </div>
                      </div>
                    </div>

                  </div>
                </section>

            </div>
          </div>
        </div>
    );
}